import { Controller } from "@hotwired/stimulus"

// Controller identifier: confirmation-modal
// Handles:
// - Generic confirmation modal management
// - Dynamic content updates with counts
export default class extends Controller {
  static targets = [
    "addingCount",
    "removingCount",
    "addingParagraph",
    "removingParagraph",
    "noChangeParagraph"
  ]
  static values = { itemType: String }
  static outlets = ["bulk-selection", "windows-event-log-toggle"]


  initialize() {
    this.currentSource = null
  }

  show(enablingCount = 0, disablingCount = 0, options = {}) {
    this.updateContent(enablingCount, disablingCount)
    // Track which controller invoked the modal so we can route cancel/confirm appropriately
    this.currentSource = options.source || null

    $(this.element).modal("show")
  }

  hide() {
    $(this.element).modal("hide")
  }

  updateContent(enablingCount = 0, disablingCount = 0) {
    const itemType = this.itemTypeValue || "source"
    const itemTypePlural = this.getPlural(itemType)

    if (this.hasAddingParagraphTarget && this.hasAddingCountTarget) {
      if (enablingCount > 0) {
        this.addingParagraphTarget.style.display = "block"
        const countText = enablingCount === 1 ? `1 ${itemType}` : `${enablingCount} ${itemTypePlural}`
        this.addingCountTarget.textContent = countText
      } else {
        this.addingParagraphTarget.style.display = "none"
      }
    }


    if (this.hasRemovingParagraphTarget && this.hasRemovingCountTarget) {
      if (disablingCount > 0) {
        this.removingParagraphTarget.style.display = "block"
        const countText = disablingCount === 1 ? `1 ${itemType}` : `${disablingCount} ${itemTypePlural}`
        this.removingCountTarget.textContent = countText
      } else {
        this.removingParagraphTarget.style.display = "none"
      }
    }

    // Show a default message if no changes are detected
    if (this.hasNoChangeParagraphTarget) {
      const hasChanges = (enablingCount > 0) || (disablingCount > 0)
      this.noChangeParagraphTarget.style.display = hasChanges ? "none" : "block"
    }
  }

  getPlural(word) {
    const plurals = {
      "source": "sources",
      "organization": "organizations",
      "agent": "agents",
      "endpoint": "endpoints"
    }

    return plurals[word] || `${word}s`
  }

  confirm() {
    if (this.currentSource === "bulk-selection" && this.hasBulkSelectionOutlet) {
      this.bulkSelectionOutlet.submitForm()
    } else if (this.currentSource === "windows-event-log-toggle" && this.hasWindowsEventLogToggleOutlet) {
      this.windowsEventLogToggleOutlet.submitForm()
    }

    this.currentSource = null
    this.hide()
  }

  cancel() {
    if (this.currentSource === "bulk-selection" && this.hasBulkSelectionOutlet) {
      this.bulkSelectionOutlet.resetForm()
    } else if (this.currentSource === "windows-event-log-toggle" && this.hasWindowsEventLogToggleOutlet) {
      this.windowsEventLogToggleOutlet.resetForm()
    }
    this.currentSource = null

    this.hide()
  }
}
